import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Table, TableBody, TableRow, Grid, Divider, Box } from '@mui/material';
import { Card, CollapseCard, Typography } from '@totalsoft/rocket-ui';
import FinancedOffersAssetItemComponent from './FinancedOffersAssetItemComponent';
import FinancedOffersPartnerItemComponent from './FinancedOffersPartnerItemComponent';
import FinancedOffersItemComponentSummary from './FinancedOffersItemComponentSummary';
import { BoldTableHead, DenseTableCell } from 'components/common/CommonStyles';

export const FinancedOffersListItemComponent = ({
  clientName,
  offerNumber,
  onChange,
  offerId,
  offerSiteId,
  currentOfferId,
  currentOfferSiteId,
  isSelectionMode,
  selected,
  offerDate,
  financedAmount,
  currency,
  t,
  offerStateName,
  assets,
  openFinancedOffer,
  openFolder,
  openMasterPartner,
  openOfferClientQuestionnaire,
  masterPartnerApp,
  offerFinancialProduct,
  offerRezidualPercent,
  offerBaloonPercent,
  offerShowBaloon,
  contractRezidualPercent,
  remainingDuration,
  contractDuration,
  offerAdvancePercent,
  offerDuration,
  offerPartners,
  offerCellParametrization,
  displayAssociatedPartners,
  outstandingAmount,
  documentTypeId,
  uninvoicedAdvance,
  onBlockFacilitySublimitAmountManually,
  hasERPFacility,
  facilityNumber,
  isFacilityBlocked,
  webFacilityId,
  webFacilitySiteId
}) => {
  var expansionPanelSummaryContent = (
    <FinancedOffersItemComponentSummary
      offerNumber={offerNumber}
      offerId={offerId}
      offerSiteId={offerSiteId}
      offerStateName={offerStateName}
      currentOfferId={currentOfferId}
      currentOfferSiteId={currentOfferSiteId}
      offerFinancialProduct={offerFinancialProduct}
      offerRezidualPercent={offerRezidualPercent}
      offerBaloonPercent={offerBaloonPercent}
      offerShowBaloon={offerShowBaloon}
      contractRezidualPercent={contractRezidualPercent}
      remainingDuration={remainingDuration}
      contractDuration={contractDuration}
      offerAdvancePercent={offerAdvancePercent}
      financedAmount={financedAmount}
      currency={currency}
      clientName={clientName}
      openFinancedOffer={openFinancedOffer}
      offerDate={offerDate}
      isSelectionMode={isSelectionMode}
      selected={selected}
      onChange={onChange}
      offerDuration={offerDuration}
      offerCellParametrization={offerCellParametrization}
      outstandingAmount={outstandingAmount}
      documentTypeId={documentTypeId}
      uninvoicedAdvance={uninvoicedAdvance}
      onBlockFacilitySublimitAmountManually={onBlockFacilitySublimitAmountManually}
      hasERPFacility={hasERPFacility}
      facilityNumber={facilityNumber}
      isFacilityBlocked={isFacilityBlocked}
      webFacilityId={webFacilityId}
      webFacilitySiteId={webFacilitySiteId}
    />
  );

  var offerPartnersDetails = (
    <Table>
      <BoldTableHead>
        <TableRow>
          <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Partner.PartnerName')}>
            {t('Folder.GeneralData.FinancedOffers.Partner.PartnerName')}
          </DenseTableCell>
          <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Partner.PartnerRole')}>
            {t('Folder.GeneralData.FinancedOffers.Partner.PartnerRole')}
          </DenseTableCell>
          <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Partner.FolderNumber')}>
            {t('Folder.GeneralData.FinancedOffers.Partner.FolderNumber')}
          </DenseTableCell>
        </TableRow>
      </BoldTableHead>
      <TableBody>
        {offerPartners.map(offerPartner => {
          return (
            <FinancedOffersPartnerItemComponent
              offerPartner={offerPartner}
              openFolder={openFolder}
              openOfferClientQuestionnaire={openOfferClientQuestionnaire}
              openMasterPartner={openMasterPartner}
              masterPartnerApp={masterPartnerApp}
              key={offerPartner.partnerId}
            />
          );
        })}
      </TableBody>
    </Table>
  );

  var expansionPanelDetails = (
    <Box overflow='auto'>
      <Table>
        <BoldTableHead>
          <TableRow>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.AssetName')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.AssetName')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.PriceWithoutVAT')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.PriceWithoutVAT')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.PriceWithVAT')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.PriceWithVAT')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.OptionalPrice')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.OptionalPrice')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.Dealer')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.Dealer')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.Discount')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.Discount')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.DiscountPercent')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.DiscountPercent')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.AssetType')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.AssetType')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.AcquisitionType')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.AcquisitionType')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.ChassisNumber')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.ChassisNumber')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.Km')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.Km')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.FabricationYear')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.FabricationYear')}
            </DenseTableCell>
            <DenseTableCell title={t('Folder.GeneralData.FinancedOffers.Asset.AgreedKm')}>
              {t('Folder.GeneralData.FinancedOffers.Asset.AgreedKm')}
            </DenseTableCell>
          </TableRow>
        </BoldTableHead>
        <TableBody>
          {assets.map(asset => {
            return <FinancedOffersAssetItemComponent asset={asset} key={asset.id} documentTypeId={documentTypeId} />;
          })}
        </TableBody>
      </Table>
    </Box>
  );

  return isSelectionMode ? (
    <Card>
      {expansionPanelSummaryContent}
      {expansionPanelDetails}
    </Card>
  ) : (
    <CollapseCard title={expansionPanelSummaryContent} toggleOnHeaderClick defaultExpanded>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography color='primary' fontWeight='bold' variant='subtitle1'>
            {t('Folder.GeneralData.FinancedOffers.Assets')}
          </Typography>
          {expansionPanelDetails}
        </Grid>
        {displayAssociatedPartners && (
          <>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography color='primary' fontWeight='bold' variant='subtitle1'>
                {t('Folder.GeneralData.FinancedOffers.Partners')}
              </Typography>
              {offerPartnersDetails}
            </Grid>
          </>
        )}
      </Grid>
    </CollapseCard>
  );
};

FinancedOffersListItemComponent.propTypes = {
  clientName: PropTypes.string,
  offerNumber: PropTypes.string.isRequired,
  offerPartners: PropTypes.array.isRequired,
  offerId: PropTypes.number.isRequired,
  offerSiteId: PropTypes.number.isRequired,
  currentOfferId: PropTypes.number.isRequired,
  currentOfferSiteId: PropTypes.number.isRequired,
  financedAmount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  assets: PropTypes.array.isRequired,
  openFinancedOffer: PropTypes.func.isRequired,
  openFolder: PropTypes.func.isRequired,
  openMasterPartner: PropTypes.func.isRequired,
  openOfferClientQuestionnaire: PropTypes.func.isRequired,
  masterPartnerApp: PropTypes.bool,
  offerStateName: PropTypes.string.isRequired,
  offerDate: PropTypes.string.isRequired,
  isSelectionMode: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  t: PropTypes.func.isRequired,
  offerFinancialProduct: PropTypes.string,
  offerRezidualPercent: PropTypes.number.isRequired,
  offerBaloonPercent: PropTypes.number,
  offerShowBaloon: PropTypes.bool,
  contractRezidualPercent: PropTypes.number,
  remainingDuration: PropTypes.number,
  contractDuration: PropTypes.number,
  offerAdvancePercent: PropTypes.number.isRequired,
  offerDuration: PropTypes.number.isRequired,
  displayAssociatedPartners: PropTypes.bool,
  offerCellParametrization: PropTypes.bool.isRequired,
  outstandingAmount: PropTypes.number,
  documentTypeId: PropTypes.number.isRequired,
  uninvoicedAdvance: PropTypes.number,
  onBlockFacilitySublimitAmountManually: PropTypes.func,
  hasERPFacility: PropTypes.bool,
  facilityNumber: PropTypes.string,
  isFacilityBlocked: PropTypes.bool,
  webFacilityId: PropTypes.number,
  webFacilitySiteId: PropTypes.number
};

export default compose(withTranslation())(FinancedOffersListItemComponent);
